import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const capacitacionesRef = useRef(null)
  const [isCapacitacionesOpen, setIsCapacitacionesOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Inicio', path: '/homepage-literary-universe-hub', icon: 'Home' },
    { name: 'Biografía', path: '/biography', icon: 'User' },
    { name: 'Libros', path: '/complete-works-library', icon: 'BookOpen' },
    {
      name: 'Capacitaciones',
      path: '/historical-research-archive',
      icon: 'GraduationCap',
      subItems: [
        { name: 'Talleres Grupales', path: '/historical-research-archive' },
          { name: 'Capacitaciones de Empresas', path: '/companies-coaches' },
        { name: 'Servicios Astrológicos', path: '/astrologic-services' },
        { name: 'Redacción y Oratoria para Ejecutivos', path: '/oratory' },
        { name: 'Lectura de Rostro para Negocios', path: '/face-lecture' },
        { name: 'Comunicación No Verbal', path: '/no-verbal-com' },
      ],
    },
    { name: 'Fotos', path: '/fotos', icon: 'Image' },
    //{ name: 'Blog', path: '/author-s-desk-articles-commentary', icon: 'FileText' },
    { name: 'Joyería', path: '/jewerly', icon: 'Gem' },
    { name: 'Lives', path: '/lives', icon: 'Image' },
  ];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(()=>{
      const handleCLickOutside = (event)=>{
          if(
              capacitacionesRef.current &&
              !capacitacionesRef.current.contains(event.target)
          ){
              setIsCapacitacionesOpen(false);
          }
      };
      document.addEventListener('mousedown',handleCLickOutside);
      return()=>{
          document.removeEventListener('mousedown',handleCLickOutside);
      };
  },[]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const toggleCapacitaciones = () => setIsCapacitacionesOpen(!isCapacitacionesOpen);

  const isActivePath = (path) => location?.pathname === path;

  return (
      <header
          className={`fixed top-0 left-0 right-0 z-50 literary-transition ${
              isScrolled
                  ? 'bg-background/95 backdrop-blur-sm literary-shadow'
                  : 'bg-background'
          }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center justify-center gap-4 xl:gap-6 flex-1 min-w-0 overflow-visible">
              {navigationItems.map((item) => (
                  <div key={item.path} className="relative group">
                    {item.subItems ? (
                        <>
                          <button
                              onClick={toggleCapacitaciones}
                              className={`flex items-center space-x-2 px-3 py-2 rounded-md font-body text-sm font-medium literary-transition ${
                                  isActivePath(item.path)
                                      ? 'text-primary bg-primary/5 border-b-2 border-primary'
                                      : 'text-foreground hover:text-primary hover:bg-primary/5'
                              }`}
                          >
                            <Icon name={item.icon} size={18} />
                            <span className="truncate max-w-[120px] xl:max-w-none">
                                {item.name}
                            </span>
                            <Icon
                                name={isCapacitacionesOpen ? 'ChevronUp' : 'ChevronDown'}
                                size={14}
                                className="ml-1"
                            />
                          </button>

                          {/* Submenu */}
                          <div
                              className={`absolute left-0 mt-2 w-64 bg-background border literary-border rounded-lg shadow-lg transition-all duration-200 origin-top ${
                                  isCapacitacionesOpen
                                      ? 'opacity-100 scale-100 visible'
                                      : 'opacity-0 scale-95 invisible'
                              }`}
                          >
                            {item.subItems.map((sub) => (
                                <Link
                                    key={sub.path}
                                    to={sub.path}
                                    className="block px-4 py-2 text-sm text-foreground hover:text-primary hover:bg-primary/5 rounded-md"
                                >
                                  {sub.name}
                                </Link>
                            ))}
                          </div>
                        </>
                    ) : (
                        <Link
                            to={item.path}
                            className={`flex items-center space-x-2 px-3 py-2 rounded-md font-body text-sm font-medium literary-transition ${
                                isActivePath(item.path)
                                    ? 'text-primary bg-primary/5 border-b-2 border-primary'
                                    : 'text-foreground hover:text-primary hover:bg-primary/5'
                            }`}
                        >
                          <Icon name={item.icon} size={18} />
                          <span>{item.name}</span>
                        </Link>
                    )}
                  </div>
              ))}

              {/* Redes sociales */}
              <div className="flex items-center space-x-4 ml-4">
                <a
                    href="https://www.youtube.com/@RosaMariaCifuentesCanalOficial"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary"
                >
                  <Icon name="Youtube" size={20} />
                </a>
                <a
                    href="https://www.instagram.com/rmcifuentes/?hl=es-la"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary"
                >
                  <Icon name="Instagram" size={20} />
                </a>
                <a
                    href="https://www.facebook.com/p/Rosa-Mar%C3%ADa-Cifuentes-100064454631254/?locale=es_LA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary"
                >
                  <Icon name="Facebook" size={20} />
                </a>
              </div>
            </nav>
            {/* Logo + Nombre */}
            <Link
                to="/homepage-literary-universe-hub"
                className="
                    flex items-center gap-2 shrink-0
                    ml-2 lg:ml-0
                    literary-transition hover:opacity-80
                    flex-row lg:flex-row-reverse
                "
                onClick={closeMenu}
            >
              {/* Imagen Rosa María */}
              <img
                  src="/assets/images/rosamariacifuentes.jpg"
                  alt="Rosa María Cifuentes"
                  className="
                    w-9 h-9
                    sm:w-10 sm:h-10
                    lg:w-12 lg:h-12
                    rounded-full
                    object-cover
                    border border-primary/30
                    shadow-sm
                "
              />

              {/* Nombre */}
              <h1
                  className="
                    font-headline font-bold text-primary leading-tight
                    text-lg sm:text-xl lg:text-2xl
                    whitespace-nowrap
                  "
              >
                {/* Nombre completo: mobile + desktop grande */}
                <span className="inline lg:hidden xl:inline">
                  Rosa María Cifuentes
                </span>

                {/* Nombre corto: desktop pequeño */}
                <span className="hidden lg:inline xl:hidden">
                  RMC
                </span>
              </h1>
            </Link>

            {/* Mobile Menu Button */}
            <button
                onClick={toggleMenu}
                className="lg:hidden p-2 rounded-md literary-transition text-foreground hover:text-primary hover:bg-primary/5 mr-4"
                aria-label="Toggle menu"
            >
              <Icon name={isMenuOpen ? 'X' : 'Menu'} size={24} />
            </button>
          </div>

          {/* Mobile Navigation */}
          <div
              className={`lg:hidden literary-transition-complex overflow-hidden ${
                  isMenuOpen
                      ? 'max-h-screen opacity-100 shadow-lg border-t border-primary/10'
                      : 'max-h-0 opacity-0'
              }`}
          >
          <nav className="px-4 py-4 bg-background/95 backdrop-blur-sm">
              <div className="space-y-2">
                {navigationItems.map((item) =>
                    item.subItems ? (
                        <div key={item.path} className="relative group" ref={capacitacionesRef}>
                          <button
                              onClick={toggleCapacitaciones}
                              className={`flex items-center w-full space-x-3 px-4 py-3 rounded-lg literary-transition font-body ${
                                  isActivePath(item.path)
                                      ? 'text-primary bg-primary/10 border-l-4 border-primary'
                                      : 'text-foreground hover:text-primary hover:bg-primary/5'
                              }`}
                          >
                            <Icon name={item.icon} size={20} />
                            <span className="font-medium">{item.name}</span>
                            <Icon
                                name={isCapacitacionesOpen ? 'ChevronUp' : 'ChevronDown'}
                                size={16}
                                className="ml-auto"
                            />
                          </button>

                          {/* Submenu mobile */}
                          {isCapacitacionesOpen && (
                              <div className="ml-8 mt-1 space-y-1">
                                {item.subItems.map((sub) => (
                                    <Link
                                        key={sub.path}
                                        to={sub.path}
                                        onClick={closeMenu}
                                        className="block px-3 py-2 text-sm rounded-md text-foreground hover:text-primary hover:bg-primary/5"
                                    >
                                      {sub.name}
                                    </Link>
                                ))}
                              </div>
                          )}
                        </div>
                    ) : (
                        <Link
                            key={item.path}
                            to={item.path}
                            onClick={closeMenu}
                            className={`flex items-center space-x-3 px-4 py-3 rounded-lg literary-transition font-body ${
                                isActivePath(item.path)
                                    ? 'text-primary bg-primary/10 border-l-4 border-primary'
                                    : 'text-foreground hover:text-primary hover:bg-primary/5'
                            }`}
                        >
                          <Icon name={item.icon} size={20} />
                          <span className="font-medium">{item.name}</span>
                        </Link>
                    )
                )}
              </div>

              {/* Redes sociales en móvil */}
              <div className="flex items-center space-x-6 mt-4 px-4">
                <a href="https://www.youtube.com/@RosaMariaCifuentesCanalOficial" target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                  <Icon name="Youtube" size={20} />
                </a>
                <a href="https://www.instagram.com/rmcifuentes/?hl=es-la" target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                  <Icon name="Instagram" size={20} />
                </a>
                <a href="https://www.facebook.com/p/Rosa-Mar%C3%ADa-Cifuentes-100064454631254/?locale=es_LA" target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                  <Icon name="Facebook" size={20} />
                </a>
              </div>
            </nav>
          </div>
        </div>
      </header>
  );
};

export default Header;
